import './navigation.scss';
import './navigation.html.twig';

export default function () {
  const el = document.querySelector('.navigation__list');
  if (!el) {
    return;
  }

  function getMode() {
    return window.innerWidth < 1024 ? 'mobile' : 'desktop';
  }

  const mobileNav = document.querySelector('.navigation__mobile-nav');
  const navSearch = document.querySelector('.navigation__search');
  const navList = document.querySelector('.navigation__list');
  const close = document.querySelector('.navigation__search__close');

  // Set initial window size
  let mode = getMode();
  // On resize, remove mobile nav if still open when it reaches desktop
  window.addEventListener('resize', () => {
    mode = getMode();
    if (mode === 'desktop') {
      navList.classList.remove('navigation__list--open');
      navSearch.classList.remove('navigation__search--open');
      close.style.display = 'none';
    }
  });

  mobileNav.addEventListener('click', () => {
    el.classList.toggle('navigation__list--open');
    navSearch.classList.toggle('navigation__search--open');
    if (mobileNav.getAttribute('aria-expanded') === 'false') {
      mobileNav.setAttribute('aria-expanded', 'true');
    } else {
      mobileNav.setAttribute('aria-expanded', 'false');
    }
  });

  function closeNavItems(item) {
    const openItems = Array.from(el.querySelectorAll('.navigation__list > ul > li.active'));
    openItems.forEach((openItem) => {
      const child = openItem.querySelector('button');
      if (item !== openItem || item == null) {
        openItem.classList.remove('active');
        child.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggleNavItem(item, child) {
    item.classList.toggle('active');
    if (item.classList.contains('active')) {
      child.setAttribute('aria-expanded', 'true');
    } else {
      child.setAttribute('aria-expanded', 'false');
    }
  }

  const navItems = Array.from(el.querySelectorAll('.navigation__list > ul > li'));
  navItems.forEach((item) => {
    const button = item.querySelector('button');
    item.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', (ev) => {
      closeNavItems(item);
      toggleNavItem(item, button);

      const docClickClose = (e) => {
        if (e.target !== item || !item.contains(e.target)) {
          closeNavItems(null);
          document.removeEventListener('click', docClickClose);
        }
      };

      ev.stopPropagation();
      document.addEventListener('click', docClickClose);
    });

    item.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        item.click();
      }
    });
  });

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navSearch.classList.remove('navigation__search--open');
  };

  const openSearch = () => {
    navSearch.classList.add('navigation__search--open');
    close.style.display = 'block';
  };

  const searchButton = document.querySelector('.navigation__search__toggle');
  const searchBox = document.querySelector('.navigation__search__box');

  searchButton.addEventListener('click', () => searchBox.focus());
  searchBox.addEventListener('focus', openSearch);
  close.addEventListener('click', (e) => handleClose(e));
}
